import type { ReactNode } from 'react';

import { Icons } from '@commenda/kakashi';
import {
  ChatRoomAgentMessageKind,
  type IChatRoomMessage,
} from '@commenda/types';

type AgentThreadNoticeKind =
  | ChatRoomAgentMessageKind.MUTED_NOTICE
  | ChatRoomAgentMessageKind.RESUMED_NOTICE;

interface AgentThreadNoticeProps {
  kind: AgentThreadNoticeKind;
  message: IChatRoomMessage;
}

const AGENT_THREAD_NOTICE_CONFIG: Record<
  AgentThreadNoticeKind,
  { icon: ReactNode; fallbackCopy: string }
> = {
  [ChatRoomAgentMessageKind.MUTED_NOTICE]: {
    icon: <Icons.VolumeX className="size-3 text-text-tertiary shrink-0" />,
    fallbackCopy:
      'Commenda Agent is muted in this thread. @mention it to bring it back.',
  },
  [ChatRoomAgentMessageKind.RESUMED_NOTICE]: {
    icon: <Icons.VolumeMax className="size-3 text-text-tertiary shrink-0" />,
    fallbackCopy: 'Commenda Agent is back. @mention it to ask something.',
  },
};

const AgentThreadNotice = ({ kind, message }: AgentThreadNoticeProps) => {
  const { icon, fallbackCopy } = AGENT_THREAD_NOTICE_CONFIG[kind];

  return (
    <div className="flex items-center w-full pt-lg">
      <div className="flex-1 h-px min-w-0 bg-border-secondary" />
      <div className="flex items-center gap-sm bg-bg-primary border border-border-secondary rounded-full px-xl py-sm min-w-0">
        {icon}
        <span className="txt-extra-small-medium text-text-secondary text-center">
          {message.message || fallbackCopy}
        </span>
      </div>
      <div className="flex-1 h-px min-w-0 bg-border-secondary" />
    </div>
  );
};

export default AgentThreadNotice;
